// Default Concierge settings
const DEFAULT_CONCIERGE_SETTINGS = {
    alignment: 'right',
    horizontal_padding: 24,
    vertical_padding: 24,
    z_index: 1400,
    hide_default_launcher: false,
    custom_launcher_icon: '',
};

export { DEFAULT_CONCIERGE_SETTINGS };
//# sourceMappingURL=types.js.map
